import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractColumn from "./AbstractColumn.js";
import FormulaColumnFormulaSerializer from "./FormulaColumnFormulaSerializer.js";
import percentage from "../../../../core/percentage.js";

/**
 * A column referencing other columns through a formula. Such a column
 * can show the sum of 2 other columns for example.
 *
 * @param {AbstractFormulaNode} formula - A tree of formula
 * nodes. Some of those nodes are instances of
 * ReportReferenceFormulaNode to reference columns.
 * @param {boolean} [spec.formatInPercentage] - Whether data should be
 * formatted in percentage.
 */
export default class FormulaColumn extends AbstractColumn {
	constructor({ formula, formatInPercentage } = {}) {
		super(...arguments);

		this._formula = formula;
		this._formatInPercentage = formatInPercentage;
	}

	hasPercentageFormat() {
		return this._formatInPercentage;
	}

	getFormatter() {
		if (this._formatInPercentage) {
			return percentage.forceTwoDecimals;
		}

		return super.getFormatter(...arguments);
	}

	getFormula() {
		return this._formula;
	}

	accept(visitor) {
		return visitor.visitFormulaColumn(this);
	}

	_getDefaultTitle() {
		return _("Formula");
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		if (this._formula && this._formula.isValid()) {
			const formulaSerializer = new FormulaColumnFormulaSerializer({
				report: this._report,
			});
			properties.formula = this._formula.accept(formulaSerializer);
		}

		return properties;
	}

	static getType() {
		return "FormulaColumn";
	}
}
